import { api } from './index';

const ReportRequestService = {
  
  // isso aqui é novo, testando relatorios dinamicos
  getList() {
    return api.get('reports/list');
  },
  getReport(report){
    return api.get('reports/get-report/'+report);
  },
  getReportData(report, params, cancelToken){
    return api.get('reports/get-report-data/'+report, {params,cancelToken});
  },
  getFilterData(filter){
    return api.get('reports/get-filter-data/'+filter);
  },
  getToken(report, params){
    return api.get('reports/get-report-token/'+report, {params});
  },
  getUrlDownload(token){
    let parts = api.defaults.baseURL.split("//");
    let url = `${parts[0]}//${(parts[1] + "/reports/download?token="+token).replace("//","/")}`
    return url;
  },


  getRescues(params) {
    return api.get('reports/rescues', params);
  },
  getBrand(params) {
    return api.get('reports/brand/', params);
  },
  getBu(params) {
    return api.get('reports/bu/', params);
  },
  getTechnologies(params) {
    return api.get('reports/technologies', params)
  },
  getFieldMkt(params) {
    return api.get('reports/field-mkt/', params);
  },
  getAccelerator(params) {
    return api.get('reports/accelerator/', params);
  },
  getStatus(params) {
    return api.get('reports/status/', params);
  },
  getGeneralStatement(params) {
    return api.get('reports/generalstatement/', params);
  },
  getBus() {
    return api.get('reports/get-bus/');
  },
  getCompaniesWithUsers(params) {
    return api.get('reports/by-users-company/', params);
  },
  getCompaniesWithFundsAvailable(params) {
    return api.get('reports/resales-with-funds-available/', params);
  },
  getLeadsByCompany(params) {
    return api.get('reports/leads-company/', params);
  },
  getUserAccess(params) {
    return api.get('reports/user-access', params)
  },
  getResaleAccess(params) {
    return api.get('reports/resale-access', params)
  },
  getActions(params) {
    return api.get('reports/actions', params)
  },
  getAccountMeeting(params) {
    return api.get('reports/actions-account-meeting', params)
  },
  getAdhesionList(params) {
    return api.get('reports/adhesion-list', params)
  },
  getAdhesionListExport(params) {
    return api.get('reports/adhesion-list', {
      params: { ...params },
      responseType: 'blob'
    })
  },
  getScancashFundCompany(params) {
    return api.get('reports/scancash-fund-company', params)
  },
  getAdhesionCompanyUsers(params) {
    return api.get('reports/adhesion-company-users', params)
  },
  getHeadquarterAndSubsidiaries(params) {
    return api.get('reports/headquarter-and-subsidiaries', params)
  },
  getHeadquarterAndSubsidiariesExport(params) {
    return api.get('reports/headquarter-and-subsidiaries', {
      params: { ...params },
      responseType: 'blob'
    })
  },
  getTypeActions(params) {
    return api.get('reports/type-actions', params)
  },
  getTypeActionsExport(params) {
    return api.get('reports/type-actions', {
      params: { ...params },
      responseType: 'blob'
    })      
  }
};

export default ReportRequestService;